import React from 'react';
import { FormattedMessage } from 'react-intl';
import './SignagePlus.css';

const FooterActions = ({
  onLeftClick,
  onSave,
  leftLabel = "CANCEL",
  saveLabel = "CONTINUE",
  middleLabel = "",
  onMiddleClick,
  disableSave = false,
  disableMiddle = false,
  isSaving = false
}) => (
  <div className="border-top d-flex align-items-center px-4 py-2 playlist-fixed-bottom-container" style={{ height: "94px" }}>
    <div className="d-flex align-items-center w-100">
      <button
        type="button"
        className="btn btn-outline-secondary h-44"
        onClick={onLeftClick}
      >
        <FormattedMessage id={leftLabel} />
      </button>
      <div className="ms-auto d-flex align-items-center">
        {middleLabel && (
          <button
            type="button"
            className="btn btn-outline-secondary h-44 me-3"
            onClick={onMiddleClick}
            disabled={disableMiddle}
          >
            <FormattedMessage id={middleLabel} />
          </button>
        )}
        <button
          type="button"
          className="btn btn-primary but-darkblue btn-primary-style h-44"
          onClick={onSave}
          disabled={disableSave || isSaving}
        >
          {isSaving ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              <FormattedMessage id="SAVING" />
            </>
          ) : (
            <FormattedMessage id={saveLabel} />
          )}
        </button>
      </div>
    </div>
  </div>
);

export default FooterActions;
